const RepairFileStatusMacroConstant = {
  DRAFT: 'DRAFT',
  IN_CREATION: 'IN_CREATION',
  IN_CREATION_ESTIMATE: 'IN_CREATION_ESTIMATE',

  IN_CREATION_PROSPECT: 'IN_CREATION_PROSPECT',

  TRANSPORT_GO: 'TRANSPORT_GO',

  RECEPTION_AT_REPAIRER: 'RECEPTION_AT_REPAIRER',

  DIAGNOSTIC_MANUFACTURER_RECEIVED: 'DIAGNOSTIC_MANUFACTURER_RECEIVED',

  DIAGNOSTIC_MANUFACTURER_PROCESSED: 'DIAGNOSTIC_MANUFACTURER_PROCESSED',

  ESTIMATE_SENT_TO_CUSTOMER: 'ESTIMATE_SENT_TO_CUSTOMER',

  ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER: 'ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER',

  IN_REPARATION: 'IN_REPARATION',

  SENT_BACK_BY_REPAIRER: 'SENT_BACK_BY_REPAIRER',

  RECEIPT_AT_STORE: 'RECEIPT_AT_STORE',

  SENT_AVAILABLE_TO_CUSTOMER: 'SENT_AVAILABLE_TO_CUSTOMER',

  TAKEOVER_BY_CUSTOMER: 'TAKEOVER_BY_CUSTOMER',

  NETWORK_BILLING: 'NETWORK_BILLING',

  FINISHED: 'FINISHED',

  ABORT_BY_CUSTOMER: 'ABORT_BY_CUSTOMER',

  DELETED: 'DELETED'
}

export default RepairFileStatusMacroConstant
